import { BLUE } from '../../styles/colors';
import { INTER } from '../../styles/fonts';
import styled from 'styled-components';

export const SwapIconContainer = (styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: #F2F6FF;
  border-color: #DCE2F1;
  border-width: 1px;
  border-style: solid;
  border-radius: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SwitchText = (styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${BLUE};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SwitchContainer = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
